/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconNavigationJobs = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M13.002 6.426a.333.333 0 0 0-.333.333V10H3.334V6.759a.333.333 0 1 0-.666 0v4.001c0 .369.298.574.667.574h3.334v1.484l-3.412 1.039a.333.333 0 1 0 .194.638l4.55-1.385 4.588 1.433a.333.333 0 0 0 .199-.637l-3.452-1.078v-1.494h3.334c.369 0 .667-.205.667-.574V6.759a.333.333 0 0 0-.333-.333z"
    />
    <path
      fill="currentColor"
      d="M4.334 9.41h7.348a.316.316 0 0 0 .316-.316c0-.043-.613-6.001-.613-6.001-.099-.927-.68-1.65-1.517-1.65H6.134c-.836 0-1.41.723-1.515 1.619l-.6 6.001a.314.314 0 0 0 .314.347z"
    />
  </svg>
);

IconNavigationJobs.displayName = 'IconNavigationJobs';

IconNavigationJobs.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconNavigationJobs);
IconNavigationJobs.displayName = 'IconNavigationJobs';
